import { useEffect, useState } from "react";

import { Capacitor } from "@capacitor/core";
import { CapacitorUpdater } from "@capgo/capacitor-updater";

import { version as packageVersion } from "../../../../package.json";

export const getCurrentVersion = async () => {
  if (Capacitor.isNativePlatform()) {
    const current = await CapacitorUpdater.current();

    const currentVersion =
      current.bundle.version === "builtin"
        ? current.native
        : current.bundle.version;

    return currentVersion;
  } else {
    return packageVersion;
  }
};

export const useCurrentVersion = () => {
  const [version, setVersion] = useState<string | null>();

  useEffect(() => {
    getCurrentVersion().then((version) => setVersion(version));
  }, []);

  return version;
};
